import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
export type MapsPlatform = 'ios' | 'android' | 'web';

@Injectable({ providedIn: 'root' })
export class MapsLinkService {
  constructor() {}

  public static buildMapsUrl(query: string): string {
    const platform = Capacitor.getPlatform();
    const encoded = encodeURIComponent(query.trim());
    switch (platform) {
      case 'ios':
        return `maps:?q=${encoded}`;
      case 'android':
        return `geo:0,0?q=${encoded}`;
      default:
        return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
    }
  }

  public openAddress(query: string): void {
    const url = MapsLinkService.buildMapsUrl(query);
    if (Capacitor.isNativePlatform) {
      // the WebView delegates maps:/geo: schemes to the OS
      window.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener');
    }
  }
}
